import React, {ReactElement, useCallback, useEffect, useState} from 'react';
import CustomRoute from '../../constants/route/CustomRoute';
import {Redirect, Switch} from 'react-router-dom';
import {connect} from 'react-redux';
import AuthUtils from '../../utils/AuthUtils';
import {_initApp} from '@shared/store/actions/AuthActions';
import Loader from '@components/framework/loader/Loader';
import InitSharedRepo from '../../../../shared';

const Admin = (props: any): ReactElement => {
  const {adminAuthToken, initApp} = props;
  const [isLoading, setLoading] = useState(true);
  const adminRoute = CustomRoute.admin;

  const handleAppEntry = useCallback(() => {
    const token = AuthUtils.getAdminAuthToken();
    initApp({adminAuthToken: token});
    InitSharedRepo.initAfterAuth({token});
    setLoading(false);
  }, [initApp]);

  useEffect(() => {
    handleAppEntry();
  }, [handleAppEntry]);

  const renderAdminRoutes = () => {
    const returnRoute = CustomRoute.basicRoute(adminRoute, adminAuthToken);
    return (
      <Switch>
        <Redirect
          to={adminRoute.redirectTo}
          from={adminRoute.exactFrom}
          exact
        />
        {returnRoute}
      </Switch>
    );
  };

  if (isLoading) {
    return (
      <div className="flex-centering">
        <Loader size={56} color="primary" />
      </div>
    );
  } else {
    return renderAdminRoutes();
  }
};

function mapStateToProps(state: any) {
  // Properties defined here (read from state) will be available as props in the component
  return {
    adminAuthToken: state.auth.adminAuthToken
  };
}

export default connect(mapStateToProps, {
  initApp: _initApp
})(Admin);
